import React from 'react'
import PropTypes from 'prop-types'

const lineStyle = {
  fill: 'none',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  strokeMiterlimit: 10,
}

const CrossIcon = ({ customClassName, width, height, fill, }) =>
  (<svg
    className={customClassName}
    width={width}
    height={height}
    aria-labelledby="Cross"
    viewBox="0 0 50 50"
  >
    <title id="cross-icon">Cross</title>
    <g>
      <polyline stroke={fill} style={lineStyle} points="16,34 25,25 34,16 " />
      <polyline stroke={fill} style={lineStyle} points="16,16 25,25 34,34 " />
    </g>
  </svg>)

CrossIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  customClassName: PropTypes.string,
}

CrossIcon.defaultProps = {
  width: 20,
  height: undefined,
  fill: 'blue',
  customClassName: '',
}

export default CrossIcon



// WEBPACK FOOTER //
// ./src/components/icons/Cross.js